import Box from "../primitives/box";

/**
 * @deprecated Use noted components package instead.
 */
export const TableFooter = Box.withComponent("tfoot");

TableFooter.displayName = "TableFooter";
